import React from "react";
import LandingPageGsap from "../GSAPLP/LandingPageGsap";

export default function LandingPage() {
  return (
    <>
      <LandingPageGsap />
    </>
  );
}
